"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.reset_password = void 0;
var auth_1 = require("firebase/auth");
var firebase_1 = require("../../../../firebase");
var firebaseErrors_1 = require("../../../../helpers/firebaseErrors");
var messages_1 = require("./constants/messages");
function reset_password(request) {
    return __awaiter(this, void 0, void 0, function () {
        var userCredential, error_1, errorMessage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0, auth_1.confirmPasswordReset)(firebase_1.auth, request.code, request.password)];
                case 1:
                    userCredential = _a.sent();
                    return [2 /*return*/, { success: true, message: "Password changed successfully. Please sign in.", content: { is_loading: false } }];
                case 2:
                    error_1 = _a.sent();
                    errorMessage = "";
                    switch (error_1 === null || error_1 === void 0 ? void 0 : error_1.code) {
                        case messages_1.EXPIRED_ACTION_CODE:
                            errorMessage = "This password reset link expired, please request a new link.";
                            break;
                        case messages_1.INVALID_ACTION_CODE:
                            errorMessage = "This password reset link is not valid, please request a new link.";
                            break;
                        default:
                            errorMessage = (0, firebaseErrors_1.decodeFirebaseError)(error_1);
                    }
                    return [2 /*return*/, { success: false, message: errorMessage, content: { is_loading: false } }];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.reset_password = reset_password;
